module.exports = __webpack_public_path__ + "static/img/100_own_emblem_bmw_3.ea1cb71.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/100_own_emblem_bmw_3.jpeg
// module id = /ilj
// module chunks = 1